import { render } from "./channel.vue?vue&type=template&id=89ca48ea&scoped=true"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"

import "./channel.vue?vue&type=style&index=0&id=89ca48ea&scoped=true&lang=css"

import exportComponent from "H:\\YangLei\\code\\meijuehaotaitai\\ui\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ca48ea"]])

export default __exports__